import { useQuery } from "@tanstack/react-query"

import type { WorkflowItem } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function getWorkflow(id: string): Promise<WorkflowItem> {
  return api.get(`/explorer/workflow/${id}`)
}

export function useGetWorkflow(id: string) {
  return useQuery({
    queryKey: queryKeys.workflow(id),
    queryFn: () => getWorkflow(id),
    enabled: !!id,
  })
}
